export default __webpack_public_path__ + "a7fcf699d3dcef85d8882032bfe9b89a.svg";